import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import CircularProgress from '@material-ui/core/CircularProgress';
import SimpleButton from '~/styles/components/SimpleButton';
import Backdrop from '~/components/BackdropComponent';
import { errorMessage } from '~/utils/Message';

import { download } from '~/services/xlsx';
import api from '~/services/api';

import { Container } from './styles';
import { SubTitle } from '../../styles';

function Patient() {
  const profile = useSelector((state) => state.user.profile);
  const hemocenter_id = profile.hemocenter ? profile.hemocenter.id : undefined;

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = 'Relatório de pacientes | ClickHemofilia';
  }, []);

  async function handleSubmit() {
    setLoading(true);

    try {
      const response = await api.get('/report/patients', {
        params: {
          hemocenter_id,
        },
        responseType: 'blob',
      });

      download(response.data);
    } catch (error) {
      if (error.response.status === 400) {
        errorMessage('There were no records in this time interval');
      } else {
        errorMessage(error);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container>
      <SubTitle>
        Todos os pacientes serão recuperados ao emitir o relatório
      </SubTitle>

      <SimpleButton onClick={handleSubmit}>Gerar relatório</SimpleButton>

      <Backdrop open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Container>
  );
}

export default Patient;
